import { HTTPClient } from "../common/HTTPClient";

import { PaginationRequestParams } from "@/common/mixins/pagination";

export class DeliveryModeClient {
  constructor(private httpClient: HTTPClient) {}

  public async getDeliveryModes(params: PaginationRequestParams): Promise<any> {
    const { data } = await this.httpClient.request({
      url: "/delivery-modes",
      method: "GET",
      params
    });

    return data;
  }

  public async getDeliveryModesByShopId(shopId: number): Promise<any> {
    const { data } = await this.httpClient.request({
      url: `/delivery-modes/shop/${shopId}`,
      method: "GET"
    });

    return data;
  }

  public async getDeliveryAttributeByDeliveryId(
    deliveryId: number
  ): Promise<any> {
    const { data } = await this.httpClient.request({
      url: `/delivery-attribute-metas/delivery/${deliveryId}`,
      method: "GET"
    });

    return data;
  }
}
